module.exports = __webpack_public_path__ + "img/posterSearch-des5.44bd524f.png";